module.exports = __webpack_public_path__ + "static/media/NunitoSans_7pt-Bold.5eca7f02.ttf";